import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-service-error',
  templateUrl: './service-error.component.html',
  styleUrls: ['./service-error.component.scss'],
  standalone: false
})
export class ServiceErrorComponent {
  constructor(public authService: AuthService, public router: Router) { }
  openContactForm(): void {
    const url = `https://itsm-servicedesk.temenos.com`;
    window.open(url, '_blank');
  }

  refreshPage() {
    window.location.reload();
  }
}
